import script from "./SettingsDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsDialog.vue?vue&type=script&lang=ts&setup=true"

import "./SettingsDialog.vue?vue&type=style&index=0&id=3f3c8337&lang=sass"

const __exports__ = script;

export default __exports__